<!-- static item -->
@if (cartItem.description) {
  @for (desc of splitDescription(cartItem.description); track desc) {
    <div>
      <mbnm-cart-item-part [cartItem]="cartItem"
        [format]="'<' + desc + '>'">
      </mbnm-cart-item-part>
    </div>
  }
}

<!-- samples -->
@if (samples && samples.length > 0) {
  <div class="samples-description">
    @for (sample of samples; track sample) {
      <div>
        @if (sample.groupName) {
          <div class="heading">{{ sample.groupName }}
            @if (sample.groupNameDescription) {
              {{ sample.groupNameDescription }}
            }
          </div>
        }
        <div>
          <mat-icon class="icon" svgIcon="bullet-point-circle"></mat-icon>
          @if (sample.type === 'MAT') {
            <span [innerHtml]="'<strong>' + partDisplay.description(sample) + '</strong>' + partDisplay.code(sample, ' #_') + ' (' + sample.coreType + ' Core)'"></span>
          }
          @if (sample.type === 'FRAME') {
            <span [innerHtml]="'<strong>' + partDisplay.description(sample) + '</strong> ' + partDisplay.longDescription(sample) + partDisplay.code(sample, ' (#_)')"></span>
          }
          @if (sample.type === 'BACKINGBOARD') {
            <span [innerHtml]="'<strong>' + partDisplay.description(sample).replace(' Backing Board', ':') + '</strong> ' + partDisplay.longDescription(sample)"></span>
          }
          @if (sample.type === 'GLAZING') {
            <span [innerHtml]="'<strong>' + partDisplay.description(sample).replace(' Plexiglass', ':') + '</strong> ' + partDisplay.longDescription(sample)"></span>
          }
          @if (sample.type === 'SHOWBAG') {
            <span [innerHtml]="'Show Bag <strong>' + partDisplay.description(sample) + '</strong> ' + partDisplay.longDescription(sample) + partDisplay.code(sample, ' (#_)')"></span>
          }
          @if (sample.type === 'SAMPLE_PACK') {
            <span [innerHtml]="partDisplay.description(sample)"></span>
          }
        </div>
      </div>
    }
  </div>
}


@if (!cartItem.description && (!samples || samples.length === 0)) {
  <div class="non-product-details">
    <mbnm-cart-item-part [cartItem]="cartItem" [hideBullet]="true"
      format="<{OuterSizeNumeric:size}>">
      @if (['MAT','SHOW-KIT','VALUE-PACK'].indexOf(cartItem.primaryProduct) !== -1) {
        <strong prefix>Outer Size: </strong>
      }
      @if (['MAT','SHOW-KIT','VALUE-PACK'].indexOf(cartItem.primaryProduct) === -1) {
        <strong prefix>Size: </strong>
      }
    </mbnm-cart-item-part>
    <mbnm-cart-item-part [cartItem]="cartItem" [hideBullet]="true"
      format="<{openings[0].size.width:size}> <x {openings[0].size.height:size}>">
      <strong prefix>Opening:</strong>
    </mbnm-cart-item-part>
    @if (!cartItem.description && (!samples || samples.length === 0)) {
      <mbnm-cart-item-part [cartItem]="cartItem" [hideBullet]="true"
        format="<{openingDetails}>">
        <strong prefix>Opening Details:</strong>
      </mbnm-cart-item-part>
      <mbnm-cart-item-part [cartItem]="cartItem" [hideBullet]="true"
        format="<{reveal:size}>">
        <strong prefix>Reveal:</strong>
      </mbnm-cart-item-part>
      @if (cartItem.margins?.bottom && cartItem.margins?.bottom !== cartItem.margins?.top) {
        <mbnm-cart-item-part [cartItem]="cartItem" [hideBullet]="true"
          format="<{margins.bottom:size}>">
          <strong prefix>Bottom Margin:</strong>
        </mbnm-cart-item-part>
      }
      <mbnm-cart-item-part [cartItem]="cartItem" [hideBullet]="true"
        format="<{vGrooveOffset:size}>">
        <strong prefix>V-Groove: Offset:</strong>
      </mbnm-cart-item-part>
    }
  </div>
}

@if (!cartItem.description && (!samples || samples.length === 0)) {
  <mbnm-cart-item-part [cartItem]="cartItem"
    format="<*{topMat.description}*> <#{topMat.code}> <({topMat.coreType} Core) Mat> <*({topMat.inactiveDescriptor})*> <&_*{bottomMat.description}*> <#{bottomMat.code}> <({bottomMat.coreType} Core) Accent Mat> <*({bottomMat.inactiveDescriptor})*>">
  </mbnm-cart-item-part>
  @if (cartItem.primaryProduct !== 'MIRROR') {
    <mbnm-cart-item-part [cartItem]="cartItem"
      format="<{mirror.description}>">
    </mbnm-cart-item-part>
  }
  <mbnm-cart-item-part [cartItem]="cartItem"
    format="<*{moulding.description}*:> <{moulding.longDescription}> <#{moulding.code}> </w {moulding.accessoryDescription}> <*({moulding.inactiveDescriptor})*>">
  </mbnm-cart-item-part>
  @if (cartItem.primaryProduct !== 'SHOWBAG') {
    <mbnm-cart-item-part [cartItem]="cartItem"
      format="<{bag.description}> <*({bag.inactiveDescriptor})*>">
      <span>Show Bag</span>
    </mbnm-cart-item-part>
  }
  @if (cartItem.primaryProduct !== 'BACKINGBOARD') {
    <mbnm-cart-item-part [cartItem]="cartItem"
      format="<{backingBoard.description}> <*({backingBoard.inactiveDescriptor})*>">
    </mbnm-cart-item-part>
  }
  @if (cartItem.primaryProduct !== 'GLAZING') {
    <mbnm-cart-item-part [cartItem]="cartItem"
      format="<{glazing.description}> <*({glazing.inactiveDescriptor})*>">
    </mbnm-cart-item-part>
  }
  <!--
  // NOTE: not using upsells in cart right now.. keep in case we want to use later
  <div class="upsell" *ngIf="upsell && cartItem.topMat && (!cartItem.bottomMat! && cartItem.openings.length > 0 || !cartItem.moulding)">
    <a mat-mini-fab class="close" color="secondary" (click)="upsell = false">
      <mat-icon svgIcon="x"></mat-icon>
    </a>
    <div *ngIf="cartItem.topMat && !cartItem.bottomMat && cartItem.openings.length > 0">
      <mat-icon color="secondary" (click)="upsellInfo('bottomMat')" svgIcon="information-outline"></mat-icon>
      <span>
        Consider Adding an Accent Mat
      </span>
      <button [routerLink]="'/edit/bottomMat/' + cartItem.id" mat-flat-button color="primary">Choose <mat-icon svgIcon="chevron-right"></mat-icon></button>
    </div>
    <hr *ngIf="cartItem.topMat && !cartItem.bottomMat! && !cartItem.moulding" />
    <div *ngIf="cartItem.topMat && !cartItem.moulding">
      <mat-icon color="secondary" (click)="upsellInfo('moulding')" svgIcon="information-outline"></mat-icon>
      <span>
        Consider Adding a Frame
      </span>
      <button [routerLink]="'/edit/moulding/' + cartItem.id" mat-flat-button color="primary">Choose <mat-icon svgIcon="chevron-right"></mat-icon></button>
    </div>
  </div>
  -->
}

<mbnm-cart-item-part [cartItem]="cartItem"
  format="<{instructions}>">
  <strong content>Special Instructions:</strong>
</mbnm-cart-item-part>
